/* Used by Storefront */
import React from "react";
import { LinkedResourceResult } from "~/common/Store/models/Category";
import ResourceLink from "./ResourceLink";
interface Props {
  linkedResources: LinkedResourceResult[];
  isAdditional?: boolean;
}
const NonFeaturedResources = ({
  linkedResources,
  isAdditional = true
}: Props) => {
  return <>
      {linkedResources && linkedResources.length > 0 && <div className="resources">
          <p className="header-4">{`${isAdditional ? "Additional " : ""}Resources`}</p>
          {linkedResources.map(resource => <ResourceLink link={resource.link} title={resource.title} displayResourceLink key={resource.title} />)}
        </div>}
    </>;
};
export default NonFeaturedResources;